import PptxGenJS from "pptxgenjs";
import { TEXT_OPTIONS } from "../masters/components";
import { TemplateData } from "..";
import { parseMarkdownToPptxText } from "../../../markdownParser";

const RIGHT_COLUMN_X = 8.68;
const LEFT_COLUMN_X = 0.52;
const COLUMN_Y = 2.38;

export const addSummarySlide = (pres: PptxGenJS, data: TemplateData) => {
  const slide = pres.addSlide({ masterName: "SPLIT_TOP_MASTER" });
  slide.addText("Summary", { placeholder: "title" });

  const keyStrengths = data.keyStrengths?.trim();
  const keyDevelopmentOpportunities = data.keyDevelopmentOpportunities?.trim();

  if (data.candidateName) {
    slide.addText(data.candidateName, {
      ...TEXT_OPTIONS.caption,
      x: LEFT_COLUMN_X,
      y: 1.14,
      fontSize: 18,
    });
  }

  const columnsBaseOptions = {
    y: COLUMN_Y,
    w: 6.81,
    h: 5.2,
    valign: "top",
  } as const;

  slide.addText(
    [
      {
        text: "Key Strengths",
        options: { ...TEXT_OPTIONS.caption, align: "left" },
      },
      ...(keyStrengths ? parseMarkdownToPptxText(keyStrengths) : []),
    ],
    {
      ...columnsBaseOptions,
      x: LEFT_COLUMN_X,
    }
  );

  slide.addText(
    [
      {
        text: "Key development opportunities",
        options: { ...TEXT_OPTIONS.caption, align: "left" },
      },
      ...(keyDevelopmentOpportunities
        ? parseMarkdownToPptxText(keyDevelopmentOpportunities)
        : []),
    ],
    {
      ...columnsBaseOptions,
      x: RIGHT_COLUMN_X,
    }
  );
};
